import editor from "./editor";
import commonHelpers from "common/plugins/issues/topic_present_and_duration_in_range";
import reasonViewer from "./reason_viewer";

export default {
  ...commonHelpers,
  editor,
  ...reasonViewer,
};
